<template>
    <div class="pages changeRecord">
        <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
            <el-radio-button label="1">积分变更记录</el-radio-button>
            <el-radio-button label="2">等级变更记录</el-radio-button>
        </el-radio-group>
        <div v-show="tabPosition==1">
        
            <div class="f3 mb-30">
                <el-form :inline="true" label-width="100px" :model="query" class="demo-form-inline">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item class="formItem" label="搜索客户：">
                                <el-input
                                class="iptRdio"
                                placeholder="请搜索客户昵称/手机号"
                                suffix-icon="el-icon-search"
                                v-model="query.keyword_search"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="会员来源：">
                                <el-select class="iptRdio" v-model="value" placeholder="请选择会员来源">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="积分筛选：">
                                <el-popover
                                placement="bottom"
                                width="300"
                                trigger="click">
                                    <div class="popContent">
                                        <p>请输入积分分值范围</p>
                                        <div>
                                            <el-input
                                            class="iptRdio"
                                            placeholder="请输入分值"
                                            v-model="query.keyword_search"
                                            ></el-input>
                                            <span>~</span>
                                            <el-input
                                            class="iptRdio"
                                            placeholder="请输入分值"
                                            v-model="query.keyword_search"
                                            ></el-input>
                                        </div>
                                    </div>
                                    <el-input
                                    readonly
                                    class="iptRdio"
                                    slot="reference"
                                    placeholder="分值范围"
                                    v-model="query.keyword_search"
                                    ></el-input>
                                </el-popover>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <div style="text-align: right;">
                                <el-button  class="reson" type="primary" round icon="el-icon-refresh-right">重置</el-button>
                               <el-button type="text" v-if="types==2" @click="types=1">收起 <i class="el-icon-arrow-up icons"></i></el-button>
                                <el-button type="text" v-if="types==1" @click="types=2">展开 <i class="el-icon-arrow-down icons"></i></el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="types==2">
                        <el-col :span="6">
                            <el-form-item class="formItem" label="群组筛选：">
                                <el-select class="iptRdio" v-model="value" placeholder="请选择会员群组">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="会员等级：">
                                <el-select class="iptRdio" v-model="value" placeholder="请选择会员等级">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="消费金额：">
                                <el-popover
                                placement="bottom"
                                width="300"
                                trigger="click">
                                    <div class="popContent">
                                        <p>请输入消费金额范围</p>
                                        <div>
                                            <el-input
                                            class="iptRdio"
                                            placeholder="请输入金额"
                                            v-model="query.keyword_search"
                                            ></el-input>
                                            <span>~</span>
                                            <el-input
                                            class="iptRdio"
                                            placeholder="请输入金额"
                                            v-model="query.keyword_search"
                                            ></el-input>
                                        </div>
                                    </div>
                                    <el-input
                                    readonly
                                    class="iptRdio"
                                    slot="reference"
                                    placeholder="分值范围"
                                    v-model="query.keyword_search"
                                    ></el-input>
                                </el-popover>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="types==2">
                        <el-col :span="6">
                            <el-form-item class="formItem" label="业务系统：">
                                <el-select class="iptRdio" v-model="value3" placeholder="请选择业务系统">
                                    <el-option
                                    v-for="item in options3"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                              
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="f4 bf">
                <div class="d1">
                    <p>
                        <!-- <img src="../../assets/images/newIcon/customerlabel_icon@2x.png" alt=""> -->
                    积分变更记录</p>
                    <p>
                        <el-button @click="showExport" style="background:#327EFF;" type="primary" round><img src="../../assets/images/newIcon/margetmiddle_derive_icon2.png" alt=""> 导出Excel</el-button>
                    </p>
                </div>
                <el-table
                    :data="tableData3"
                    :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                    style="width: 100%;"
                    :cell-style="{textAlign: 'center',fontSize:'12px'}"
                    >
                    <el-table-column
                    prop="name"
                    label="名称"
                    >
                        <template slot-scope="scope">
                            <div class="avat">
                                <span>W</span>
                                {{scope.row.name}}
                                <span>@微信</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="number"
                    label="手机号"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="xmember"
                    label="业务系统"
                    
                    cell-style="background:red;"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="lmember"
                    label="积分总额"
                >
                    </el-table-column>
                    <el-table-column
                    prop="labellv"
                    label="时间"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="status"
                    label="单比积分"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="num"
                    label="积分条件"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="labellv"
                    label="操作"
                    width='200'
                    >
                        <template slot-scope="scope">
                            <el-button @click="godetail" type="text">查看用户</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 24px;"
                    :current-page="query.page_index"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.page_size"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total"
                    ></el-pagination>
                </div>
            </div>
                
        </div>
        <div v-show="tabPosition==2">
             <div class="f3 mb-30">
                <el-form :inline="true" label-width="100px" :model="query" class="demo-form-inline">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item class="formItem" label="搜索客户：">
                                <el-input
                                class="iptRdio"
                                placeholder="请搜索客户昵称/手机号"
                                suffix-icon="el-icon-search"
                                v-model="query.keyword_search"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="会员来源：">
                                <el-select class="iptRdio" v-model="value" placeholder="请选择会员来源">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="消费金额：">
                                <el-popover
                                placement="bottom"
                                width="300"
                                trigger="click">
                                    <div class="popContent">
                                        <p>请输入消费金额范围</p>
                                        <div>
                                            <el-input
                                            class="iptRdio"
                                            placeholder="请输入金额"
                                            v-model="query.keyword_search"
                                            ></el-input>
                                            <span>~</span>
                                            <el-input
                                            class="iptRdio"
                                            placeholder="请输入金额"
                                            v-model="query.keyword_search"
                                            ></el-input>
                                        </div>
                                    </div>
                                    <el-input
                                    readonly
                                    class="iptRdio"
                                    slot="reference"
                                    placeholder="分值范围"
                                    v-model="query.keyword_search"
                                    ></el-input>
                                </el-popover>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <div style="text-align: right;">
                                <el-button  class="reson" type="primary" round icon="el-icon-refresh-right">重置</el-button>
                                <el-button type="text" v-if="types2==2" @click="types2=1">收起 <i class="el-icon-arrow-up icons"></i></el-button>
                                <el-button type="text" v-if="types2==1" @click="types2=2">展开 <i class="el-icon-arrow-down icons"></i></el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="types2==2">
                        <el-col :span="6">
                            <el-form-item class="formItem" label="群组筛选：">
                               <el-select class="iptRdio" v-model="value" placeholder="请选择会员群组">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="会员等级：">
                                <el-select class="iptRdio" v-model="value" placeholder="请选择会员等级">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item class="formItem" label="业务系统：">
                                <el-select class="iptRdio" v-model="value3" placeholder="请选择业务系统">
                                    <el-option
                                    v-for="item in options3"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                        </el-col>
                    </el-row>
                </el-form>
            </div>
             <div class="f4 bf">
                <div class="d1">
                    <p>
                        <!-- <img src="../../assets/images/newIcon/customerlabel_icon@2x.png" alt=""> -->
                    等级变更记录</p>
                    <p>
                        <el-button @click="showExport" style="background:#327EFF;" type="primary" round><img src="../../assets/images/newIcon/vip_daochu_icon.png" alt=""> 导出Excel</el-button>
                    </p>
                </div>
                <el-table
                    :data="tableData2"
                    :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                    style="width: 100%;"
                    :cell-style="{textAlign: 'center',fontSize:'12px'}"
                    >
                    <el-table-column
                    prop="name"
                    label="名称"
                    >
                        <template slot-scope="scope">
                            <div class="avat">
                                <span>W</span>
                                {{scope.row.name}}
                                <span>@微信</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="number"
                    label="手机号"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="xmember"
                    label="业务系统"
                    
                    cell-style="background:red;"
                    >
                    </el-table-column>
                    <!-- <el-table-column
                    prop="lmember"
                    label="积分总额"
                >
                    </el-table-column> -->
                    <el-table-column
                    prop="labellv"
                    label="时间"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="status"
                    label="变更等级"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="num"
                    label="变更类型"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="labellv"
                    label="操作"
                    width='200'
                    >
                        <template slot-scope="scope">
                            <el-button @click="showPopup(4)" type="text">查看用户</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 24px;"
                    :current-page="query.page_index"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.page_size"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total"
                    ></el-pagination>
                </div>
            </div>
        </div>
         <span  class="footer">
            <el-button class="quxiao" @click="handleClose" >取 消</el-button>
            <el-button type="primary"  @click="goType(2)">保 存</el-button>
            <!-- <el-button type="primary" v-if="types==3" @click="goType(2)">完成</el-button> -->
        </span>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            types:2,
            types2:2,
            value3:"",
            options3: [{
                value: '选项1',
                label: '小橘帮帮'
                }, {
                value: '选项2',
                label: '颐和中台'
            }],
            query:JSON.parse(JSON.stringify(QUERY)),
            value: '',
            total:90,
            tabPosition:1,
            tableData2: [{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"青铜会员",
                num:'后台手动调整'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                 status:"白银会员",
                num:'用户升级'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                 status:"黄金会员",
                num:'后台手动调整'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"青铜会员",
                num:'后台手动调整'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                 status:"青铜会员",
                num:'后台手动调整'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                 status:"青铜会员",
                num:'后台手动调整'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                  status:"青铜会员",
                num:'后台手动调整'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                 status:"青铜会员",
                num:'后台手动调整'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                 status:"青铜会员",
                num:'后台手动调整'
                },],
            tableData3: [{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },{
                name: '王小虎',
                number:"15324121121",
                xmember:"小橘帮帮",
                lmember:"4,323",
                labellv:"2021.10.10 18:00",
                status:"+100",
                num:'升级获得积分'
                },],
        }
    },
    methods: {
            godetail(){
                this.$router.push({name:"memberDetail"})
            },  
    },
}
</script>
<style lang="less" scoped>
    .changeRecord{
        /deep/ .el-radio-button:first-child .el-radio-button__inner{
            border-radius: 18px 0 0 18px;
        }
        /deep/ .el-radio-button:last-child .el-radio-button__inner{
            border-radius: 0 18px 18px 0;
        }
        .f3{
            background: #fff;
            border-radius: 6px;
            .el-form{
                padding:30px 15px;
                padding-bottom:15px;
            }
            /deep/ .el-form-item{
                display: flex;
                align-items: center;
            }
            //  padding:30px;
           /deep/ .el-col-3{
               width:15.5%;
           }
           /deep/ .el-col-6{
               width:26%;
           }
            .icons{
                padding: 2px;
                margin-left:10px;
                color: rgb(255, 255, 255);
                background: rgb(46, 108, 246);
                border-radius: 50%;
            }
            .reson.el-button{
                background: #2E6CF6;
            }
           
            .times.el-input__inner{
                border-radius: 30px;
                width:100%;
                height:38px;
                .el-range-separator{
                    font-size:16px;
                    color:#ccc;
                    line-height: 28px;
                }
            }
            /deep/ .formItem.el-form-item{
                width:100%;
            }
            /deep/ .el-select{
                width: 100%;
            }
            /deep/ .formItem2  .el-form-item__content{
                // width:66%;
            }
            /deep/ .el-form-item__content{
                width:calc(100% - 100px);
            }
        }
        /deep/ .el-range-editor--mini .el-range-separator{
            font-size: 16px;
            color: #ccc;
            line-height: 28px;
        }
        /deep/ .iptRdio .el-input__inner{
            border-radius: 30px;
            height:38px;
        }
        /deep/ .iptRdio  .el-input__inner{
            background: #F6F6F6;
        }
    }
    .popContent{
        padding:15px;
        p{
            margin-bottom:15px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
        }
        div{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .iptRdio{
                width:115px;
            }
            span{
                font-size: 24px;
                font-weight: 400;
                color: #ccc;
                line-height: 20px;
            }
            input{
                border-radius: 30px;
                // width:115px !important;
            }
        }
    }
    .f4{
        background: #fff;
        .avat{
            font-size:14px;
            span{
                &:first-of-type{
                    display: inline-block;
                    width: 28px;
                    height: 28px;
                    line-height: 28px;
                    border-radius: 50%;
                    background: #258EF7;
                    font-size: 18px;
                    font-weight: 500;
                    color: #FFFFFF;
                }
                &:last-child{
                    font-size: 12px;
                    font-weight: 400;
                    color: #2EA5FF;
                }
            }
        }
        border-radius: 8px;
        .d1{
            padding:15px;
            p{
                &:first-child{
                    img{
                        margin-right:10px;
                    }
                    // margin-left:30px;
                    font-size: 16px;
                    font-weight: 500;
                    color: #333940;
                    span{
                        color:#327EFF;
                    }
                }
                
            }
            display: flex;
            justify-content: space-between;
            img{
                width:16px;
                height:16px;
                vertical-align: middle;
            }
            .kh-btn.el-button{
                border-radius: 15px;
                border: 1px solid #327EFF;
                color:#327EFF;
            }
        }
        /deep/ .el-checkbox__inner{
            border-radius: 15px;
        }
        .labelLi{
            display: flex;
            align-items: center;
            justify-content: center;
            p{
                margin-right:8px;
                display: inline-block;
                width:40px;
                padding:0px 8px;
                background: rgba(211, 236, 255, 0.4);
                border-radius: 15px;
                border: 1px solid rgba(0, 145, 255, 0.11);
                font-size: 12px;
                font-weight: 400;
                color: #0091FF;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                // &:last-child{
                //     padding:0 4px;
                //     text-align: center;
                //     // border:0;
                //     // background:#fff;
                // }
                
            }
            .s{
                background: rgba(211, 236, 255, 0.4);
                border: 1px solid rgba(0, 145, 255, 0.11);
                padding: 2px 10px;
                color: #0091FF;
                border-radius: 18px;
                width: auto;
            }
        }
    }
    .footer{
        display: block;
        background: #fff;
        padding:15px 30px;
        border-top:1px solid #ededed;
        .el-button{
            border-radius: 30px;
        }
       
    }
  
    .el-pagination{
        padding-bottom:30px;
    }
</style>